import { v4 as uuid } from "uuid";
import { useState, useCallback } from "react";
import { gettAllEmailUsers, gettAllNumberUsers } from "../actions";
import { addNotification } from "../store/slices/ui-slice";
import { useAppDispatch } from "../store/hooks";

type FetchUserDetailsResult = {
  emailUsers: any[];
  phoneUsers: any[];
  loading: boolean;
  error: string | null;
  fetchDetailsByEmail: (email: string) => Promise<void>;
  fetchDetailsByPhone: (phone: string) => Promise<void>;
};

const useFetchUserDetails = (): FetchUserDetailsResult => {
  const [emailUsers, setEmailUsers] = useState<any[]>([]);
  const [phoneUsers, setPhoneUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useAppDispatch();

  const fetchDetailsByEmail = useCallback(
    async (email: string) => {
      setLoading(true);
      setError(null);

      try {
        const response = await gettAllEmailUsers(email);
        setEmailUsers(response?.data?.data || []);
      } catch (err: any) {
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message: err.message || "An unexpected error occurred.",
          })
        );
      } finally {
        setLoading(false);
      }
    },
    [dispatch]
  );

  const fetchDetailsByPhone = useCallback(
    async (phone: string) => {
      setLoading(true);
      setError(null);

      try {
        const response = await gettAllNumberUsers(phone);
        setPhoneUsers(response?.data?.data || []);
      } catch (err: any) {
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message: err.message || "An unexpected error occurred.",
          })
        );
      } finally {
        setLoading(false);
      }
    },
    [dispatch]
  );

  return {
    emailUsers,
    phoneUsers,
    loading,
    error,
    fetchDetailsByEmail,
    fetchDetailsByPhone,
  };
};

export default useFetchUserDetails;
